// 拼接url
export const contractUrl = (url, data) => {
    let queryString = '';
  
    Object.keys(data).forEach((key) => {
        const value = data[key];
        queryString += `&${key}=${value}`;
    });
    return `${url}?${queryString.substr(1)}`;
};